export default __webpack_public_path__ + "static/media/BUILD.37600950.png";